
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { getLocalizedTaxName, getEffectivePrice } from '@/utils/getters';

@Component<OrdersTable>({})
export default class OrdersTable extends Vue {
	@Getter('getRestaurant', { namespace: 'auth' }) private restaurant!: Restaurant;
	@Getter('isTaxInclusiveWithInfo', { namespace: 'auth' }) private isTaxInclusiveWithInfo!: boolean;
	@Prop({ type: Array, required: true }) orderItems!: OrderItem[];
	@Prop({ type: Object, required: true }) orderCosts!: OrderCostsSimplified;
	@Prop({ type: Boolean, required: true }) includePrices!: boolean;

	/**
	 * Get the localized name of the tax if possible.
	 *
	 * @param {string} taxName
	 * @return {string}
	 */
	private getLocalizedTaxName(taxName: string): string {
		return getLocalizedTaxName(taxName, this.restaurant);
	}

	private getEffectivePrice(item: OrderItem | Option): number | null {
		return getEffectivePrice(item);
	}
}
